module.exports = __webpack_public_path__ + "img/r4.14951ce1.jpg";